import { render, staticRenderFns } from "./TextClamp.vue?vue&type=template&id=4efd48c4&"
import script from "./TextClamp.vue?vue&type=script&lang=ts&"
export * from "./TextClamp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports